
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"14","fill":"#5EA9FF","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.667 1.167h-.583V.584h-1.75v.583H4.667V.584h-1.75v.583h-.583a1.75 1.75 0 00-1.75 1.75v8.75a1.75 1.75 0 001.75 1.75h9.333a1.75 1.75 0 001.75-1.75v-8.75a1.75 1.75 0 00-1.75-1.75zm0 10.5H2.334v-8.75h.583v.584h1.75v-.584h4.667v.584h1.75v-.584h.583v8.75z"}}),_c('path',{attrs:{"d":"M8.167 5.252H5.834v2.333h2.333V5.252zM8.167 8.168H5.834v2.333h2.333V8.168zM11.084 5.252H8.75v2.333h2.333V5.252zM5.25 5.252H2.918v2.333h2.334V5.252zM5.25 8.168H2.918v2.333h2.334V8.168z"}})])
          )
        }
      }
    